import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { text } from "@/constants/tailwind-theme";

const AboutItemComponent = ({ title, description }) => (
  <Card className="h-full border-none shadow-none">
    <CardHeader className="flex flex-row items-start gap-4 space-y-0 p-0 pb-4">
      <div className="h-20 w-1.5 shrink-0 rounded-sm bg-primary-500" />
      <CardTitle className={text.heading2}>{title}</CardTitle>
    </CardHeader>
    <CardContent className="p-0 pl-5">
      <p className={text.body1}>{description}</p>
    </CardContent>
  </Card>
);

export default AboutItemComponent;
